import React from "react";
import { Tooltip, Typography } from "@material-ui/core";
import type { FC, ReactNode } from "react";
import { useStyles } from "./RecentlyCard.styles";

export const RecentlyCardTitle: FC<{ children: ReactNode }> = ({ children }) => {
  const classes = useStyles();
  const adapter = {
    body1: classes.title,
  };
  return (
    <Tooltip title={children!}>
      <Typography component="span" variant="body1" classes={adapter}>
        {children}
      </Typography>
    </Tooltip>
  );
};
